<template>
    <div class="qingwu">
        <div class="admin_main_block">
            <div class="admin_main_block_top">
                <div class="admin_main_block_left">
                    <div>常用配置</div>
                </div>
            </div>

            <div class="admin_form_main">
                <el-tabs tab-position="left" style="min-height: 200px;">
                    <el-tab-pane label="是否开启核销"><wxpayH5></wxpayH5></el-tab-pane>
                  <!--<el-tab-pane label="客服邮箱"><wxpayApp></wxpayApp></el-tab-pane>-->
                    <el-tab-pane label="公司logo/小程序昵称"><wxpayJsApi></wxpayJsApi></el-tab-pane>
                    <el-tab-pane label="会员折扣"><wxpayMini></wxpayMini></el-tab-pane>
<!--                    <el-tab-pane label="积分商城"><alipayApp></alipayApp></el-tab-pane>-->
                    <el-tab-pane label="老用户分享新用户所得"><alipayPc></alipayPc></el-tab-pane>
                    <el-tab-pane label="新用户首次减免"><zongdzf></zongdzf></el-tab-pane>
                    <el-tab-pane label="邀请说明"><dailzf></dailzf></el-tab-pane>
<!--                    <el-tab-pane label="购买须知"><alipayH5></alipayH5></el-tab-pane>-->
                    <el-tab-pane label="订单直属上上级奖励"><putzf></putzf></el-tab-pane>

<!--                  <el-tab-pane label="骑手每单奖励"><shiysmApp></shiysmApp></el-tab-pane>-->
                  <el-tab-pane label="每天拼团次数"><pintcs></pintcs></el-tab-pane>
<!--                  <el-tab-pane label="是否开启第三方配送"><peisxz></peisxz></el-tab-pane>-->

                </el-tabs>
            </div>
        </div>
    </div>
</template>

<script>
import wxpayH5 from '@/components/admin/pay/wxpay_h5'
import wxpayApp from '@/components/admin/pay/wxpay_app'
import wxpayJsApi from '@/components/admin/pay/wxpay_jsapi'
import wxpayMini from '@/components/admin/pay/wxpay_mini'
import alipayApp from '@/components/admin/pay/alipay_app'
import alipayPc from '@/components/admin/pay/alipay_pc'
import zongdzf from '@/components/admin/pay/zongdzf'
import dailzf from '@/components/admin/pay/dailzf'
import alipayH5 from '@/components/admin/pay/alipay_h5'
import putzf from '@/components/admin/pay/putzf'
import shiysmApp from '@/components/admin/pay/shiysm_app'
import pintcs from '@/components/admin/pay/pintcs'
import peisxz from '@/components/admin/pay/peisxz'
export default {
    components: {
        wxpayH5,
        wxpayApp,
        wxpayJsApi,
        wxpayMini,
        alipayApp,
        alipayPc,
        zongdzf,
        dailzf,
        alipayH5,
        putzf,
        shiysmApp,
        pintcs,
        peisxz
    },
    props: {},
    data() {
      return {
      };
    },
    watch: {},
    computed: {},
    methods: {},
    created() {},
    mounted() {}
};
</script>
<style lang="scss" scoped>

</style>
